/**
 * Defines a custom element.
 */
export function defineCustomElement(name, element) {
    const isDefined = customElements.get(name);
    if (isDefined) {
        console.warn(`Custom element "${name}" is already defined`);
        return;
    }
    customElements.define(name, element);
}
